/**
 * `useComingSoon()` (TMMAPP-0150 U2 §B 12): the dialog a control opens when what it leads to isn't
 * built yet — "Coming soon", "We're still building this. It'll be here soon." and OK. It returns
 * `open` for the control and the `node` to render once on the page.
 */
import { useId, useState, type ReactNode } from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from '@mui/material';
import { useTranslation } from 'react-i18next';

export function useComingSoon(): { open: () => void; node: ReactNode } {
  const { t } = useTranslation();
  const [shown, setShown] = useState(false);
  const titleId = useId();
  const bodyId = useId();
  const node = (
    <Dialog
      open={shown}
      onClose={() => setShown(false)}
      aria-labelledby={titleId}
      aria-describedby={bodyId}
    >
      <DialogTitle id={titleId}>{t('comingSoon.title')}</DialogTitle>
      <DialogContent>
        <Typography id={bodyId} variant="body1">
          {t('comingSoon.body')}
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button variant="contained" onClick={() => setShown(false)}>
          {t('comingSoon.ok')}
        </Button>
      </DialogActions>
    </Dialog>
  );
  return { open: () => setShown(true), node };
}
